<template>
  <div class="loi-main">
    <ReportsHomeV2 title="Letter of Indemnity" placeholder="Job No" :sections="loiSection" :inputValue.sync="jobno" :inputDisabled="true"
      :shareContent="shareContent" @generateReport="generateReport" @shareReport="shareReport" ref="loi-main-report" :jsReport="false" :designerV2="true"
      designerV2ReportFolder="LOIForm" :designerV2ReportFile="designerV2ReportFile" :designerV2Data="designerV2Data">
      <div slot="Details_Report Type">
        <Dropdown placeholder="Report Type" :items="reportTypeList" itemKey="Description" :selectedObject.sync="selectedReportType" :isRequired="true"
          :errorMessage.sync="reportTypeError" />
        <Dropdown placeholder="Address To" :items="addressToList" itemKey="Address To" :selectedObject.sync="selectedAddressTo" :isRequired="true"
          :errorMessage.sync="addressToError" />
        <Dropdown placeholder="Forwarding Agent" :items="forwardingAgentList" itemKey="FORWARDING" :selectedObject.sync="selectedForwardingAgent" :isRequired="true"
          :errorMessage.sync="forwardingAgentError" />
      </div>
      <div slot="Details_Container List" style="height: 500px; display: flex; flex-direction: column; align-items: flex-end">
        <button v-if="containerList.length > 0" @click="selectAllContainers">Select All Containers</button>
        <TableBox v-if="containerList.length > 0" title="Containers" style="height: calc(100% - 30px)" :tableData="containerList" :selectedRow.sync="selectedContainers" :maxSelection="-1" />
      </div>
    </ReportsHomeV2>

    <PopupV2 :show="popupShow" :type="popupType" :title="popupTitle" :content="popupContent" @buttonClicked="popupShow = false" />

    <Loader :isVisible="loading" :loadingText="loadingText" :isFullScreen="true" />

    <!-- <div class="not-ready">This page is still in development<br>Some functions may not work correctly.</div> -->
  </div>
</template>

<script>
/* eslint-disable */
import ReportsHomeV2 from '@/pages/ReportsV2/ReportsHome';

const regex = /{{([^}]+)}}/g;

export default {
  components: {
    ReportsHomeV2
  },
  data: function() {
    return {
      loading: false,
      loadingText: '',

      loiSection: [
        {
          name: 'Details',
          child: [ 'Report Type', 'Container List' ],
          show: true
        }
      ],

      reportTypeList: [],
      selectedReportType: null,
      reportTypeError: '',
      addressToList: [],
      selectedAddressTo: null,
      addressToError: '',
      forwardingAgentList: [],
      selectedForwardingAgent: null,
      forwardingAgentError: '',
      shareContent: {},

      jobDetails: null,
      jsonTemplate: null,
      designerV2ReportFile: [],
      designerV2Data: null,

      containerList: [],
      selectedContainers: [],

      popupShow: false,
      popupType: 'info',
      popupTitle: 'Popup',
      popupContent: 'Content',

      jobno: '',
    }
  },
  props: {
  },
  methods: {
    getJobDetails: async function(rpt, addTo, fwd) {
      this.jobDetails = (await this.$apiCallV2(`/FreightForwarding/JobDetails?jobno=${this.jobno.trim()}&rpt=${rpt}&addressto=${addTo}&fwdAgent=${fwd}`))['JobDetails']['Job'];

      if (!rpt && !addTo && !fwd) {
        this.containerList = this.jobDetails['ContDetail'];
      }

      this.jobDetails['date'] = new Date().formatString('dd/MM/yyyy');
      this.jobDetails['POD ETA'] = this.jobDetails['POD ETA'] ? new Date(this.jobDetails['POD ETA']).formatString('dd/MM/yyyy') : '';
      this.jobDetails['POL ETA'] = this.jobDetails['POL ETA'] ? new Date(this.jobDetails['POL ETA']).formatString('dd/MM/yyyy') : '';
      this.jobDetails['containers'] = this.selectedContainers.map(c => c['Container No']).join(', ');
      this.jobDetails['containersandsize'] = this.selectedContainers.map(c => c['Container No'] + '-' + c['Size']).join(', ');

      if (this.jobDetails['LOI']) {
        if (Object.keys(this.jobDetails['LOI']).length > 0) {
          Object.keys(this.jobDetails['LOI']).forEach(l => {
            this.jobDetails[`LOI_${l}`] = this.jobDetails['LOI'][l];
          });
        }
      }
    },
    generateReport: async function() {
      let compulsoryFilled = true;

      if (!this.selectedAddressTo) {
        compulsoryFilled = false;
        this.addressToError = 'Select Address To';
      }

      if (!this.selectedReportType) {
        compulsoryFilled = false;
        this.reportTypeError = 'Select Report Type';
      }

      if (!this.selectedForwardingAgent) {
        compulsoryFilled = false;
        this.forwardingAgentError = 'Select Forwarding Agent';
      }

      if (!compulsoryFilled) {
        return;
      }

      if (this.selectedContainers.length == 0) {
        this.popupType = 'error';
        this.popupTitle = 'Cannot Generate Letter of Indemnity';
        this.popupContent = 'Please select at least one container to generate the Letter of Indemnity.';
        this.popupShow = true;

        return;
      }
      
      this.$fullscreenLoading('Generating Report');
      await this.getJobDetails('RPTLOI', this.selectedAddressTo['Address To'].split(' ').map(a => a[0]).join(''), this.selectedForwardingAgent['FORWARDING']);
      this.$fullscreenLoading();

      //#region Using DesignerV2
      this.designerV2Data = this.jobDetails;
      this.designerV2ReportFile = [ `LOI_${this.selectedReportType['docfootertype']}.json` ];
      //#endregion

      //#region Using JSReport
      // let data = JSON.stringify(this.jsonTemplate);
      // let curMatch;
      // let found = [];

      // while(curMatch = regex.exec(data)) {
      //   found.push(curMatch[1]);
      // }
      
      // found.forEach(f => {
      //   let key = f.split('.');
      //   if (key.length > 1) {
      //     data = data.split(`{{${f}}}`).join(this.jobDetails[key[0]][key[1]] ? this.jobDetails[key[0]][key[1]] : '');
      //   } else {
      //     let text = this.jobDetails[key[0]] ? this.jobDetails[key[0]] : '';
      //     text = text.split('"').join('\\"');
      //     data = data.split(`{{${f}}}`).join(text);
      //   }
      // });

      // let jsonData = null;
      // try {
      //   jsonData = JSON.parse(data.split('\n').join(', ').split('&#x0A;').join(''));
      //   await this.$refs['loi-main-report'].generateReport('Tp1Zdc-h-C', jsonData);
      // } catch (error) {
      //   console.log(error);
      // }
      

      // this.loading = false;
      //#endregion
    },
    shareReport: async function() {
      this.loading = true;
      this.loadingText = 'Generating Share Link';

      this.shareContent = {
        body: `Your Letter of Indemnity for job ${this.jobDetails['Job No']} is available at {link}`,
        subject: `Letter of Indemnity (Job No ${this.jobDetails['Job No']})`
      };
      
      let login = await this.$apiCallV2('/Login/GetDetails');
      await this.$refs['loi-main-report'].generateShareLink(`LOI_${login['LoginUserId']}_${this.$dateTime.getDateTime(new Date(), 'yyyyMMddHHmm')}`, login['ConfigCode']);

      this.loading = false;
    },

    getReportType: async function() {
      this.loading = true;
      this.loadingText = 'Getting Report Type';

      this.reportTypeList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'LOI_RptType' });

      this.loading = false;
    },
    getAddressTo: async function() {
      this.loading = true;
      this.loadingText = 'Getting Address To';

      this.addressToList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'LOI_AddressTo' });

      this.loading = false;
    },
    getForwardingAgent: async function() {
      this.loading = true;
      this.loadingText = 'Getting Forwarding Agent';

      let forwardingAgent = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'forwarding_agent' });
      this.forwardingAgentList = JSON.parse(forwardingAgent[0]['addinfojson'])['LOIRPT']['FORWARDING_AGENT'];
      let hasDefault = this.forwardingAgentList.find(f => f['Default'] == '1');
      if (hasDefault) {
        this.selectedForwardingAgent = hasDefault;
      }

      this.loading = false;
    },

    selectAllContainers: function() {
      this.selectedContainers = [];
      this.containerList.forEach(c => this.selectedContainers.push(c));
    }
  },
  async mounted() {
    let queryJobno = this.$route.query['jobno'];
    if (queryJobno) {
      this.jobno = queryJobno;

      await this.getReportType();
      await this.getAddressTo();
      await this.getForwardingAgent();
      this.getJobDetails();
    } else {
      this.popupType = 'error';
      this.popupTitle = 'Invalid Job No';
      this.popupContent = 'Please enter your Job No';
      this.popupShow = true;
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.loi-main {
  font-size: 12px;
  width: 100%;
  height: 100%;

  > .not-ready {
    color: red;
    position: fixed;
    padding: 5px;
    width: fit-content;
    height: fit-content;
    bottom: 5px;
    left: 5px;
    animation: blinkingEffect 1s linear infinite;
  }
}
</style>